import { Box, Typography } from "@mui/material";

const ReleaseNote3 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 3.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing the latest JUNE update with key enhancements designed to streamline workflows and improve usability across the Trexo Platform.
      </Typography>

      <Box>
        <Typography variant="h5" sx={{ mb: 2 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>
          <Typography variant="body2" sx={{mb:1}}>
            <strong>Help Section<span
                style={{
                  color: "green",
                  fontWeight: "bold",
                  fontSize: "0.75em",
                  verticalAlign: "super",
                }}
              >
                New!
              </span>
              </strong> 
            <br></br>
              Quickly access support and learning resources directly within JUNE through the new Help section. It includes:
              <ul style={{ margin: 0, paddingLeft: "5%" }}>
                <li style = {{marginBottom: '12px'}}>
                  <Typography>
                  <strong>Feedback - </strong> Share suggestions or report issues directly from JUNE
                  </Typography>
                </li>
                <li style = {{marginBottom: '12px'}}>
                  <Typography >
                    <strong>Release Notes</strong> - Stay informed about the latest changes.
                  </Typography>
                </li> 
                <li style = {{marginBottom: '12px'}}>
                  <Typography >
                    <strong>FAQs</strong> - Searchable, feature-specific answers for quick reference.
                  </Typography>
                </li>
                <li style = {{marginBottom: '12px'}}>
                  <Typography>
                    <strong>Tutorials</strong> - Watch short video walkthroughs to get started easily.
                  </Typography>
                </li>
              </ul>
          </Typography>

          <Typography variant="body2" sx={{mb:2}}>
            <strong> OA Shell Draft – Feature Enhancement</strong>
            <br></br>
            Generate Office Action response drafts by simply entering the application number. The system now auto-retrieves the necessary documents, with claims upload remaining optional for added flexibility.
          </Typography>

          <Typography variant="body2" sx={{mb:1}}>
            <strong>AppGen – Enhancements</strong>
            <br></br>
          </Typography>
          <ul style={{ margin: 0, paddingLeft: "5%" }}>
            <li style = {{marginBottom: '12px'}}>
              <Typography variant="body2" sx={{mb:1}}>
                  <strong>Bypass Continuation Filing</strong> – Now available as a selection under the Filing Package Type dropdown during package creation.
              </Typography>
            </li>
            <li style = {{marginBottom: '12px'}}>
            <Typography variant="body2">
                  <strong>Non-English Filing Package</strong> – Supports package generation for PCT applications where the Receiving Office is non-English.
              </Typography>
            </li>
          </ul>
          <Typography variant="body2">
                  <span>Refer to the FAQ and Tutorial sections for more details on this feature.</span>
          </Typography>
      </Box>
    </Box>
  );
};

export default ReleaseNote3;
